module.exports = __webpack_public_path__ + "img/case3.b448db54.png";